/**
 * Preise und Abos (die kommerzielle Konsole, ADR-0018 §4a), auf Deutsch.
 * Dieselben Schlüssel wie billing.fr.ts, die Referenzsprache.
 */
export const billingDe = {
  "billing.tabs.aria": "Preise und Abos",
  "billing.tab.prices": "Preise",
  "billing.tab.promos": "Aktionen",
  "billing.tab.discounts": "Rabatte",
  "billing.refreshFailed": "Die Liste konnte nicht aktualisiert werden: Sie wird wie zuvor angezeigt.",
  "billing.anyPlan": "Alle Tarife",
  "billing.planWithInterval": "{name}, Abrechnung {interval}",
  "billing.interval.month": "monatlich",
  "billing.interval.year": "jährlich",
  "billing.window": "von {from} bis {to}",
  "billing.window.endedEarly": "am {date} beendet",
  "billing.periods.whileSubscribed": "solange das Abo läuft",
  "billing.periods.count": "{count} bezahlte Zeiträume",
  "billing.state.scheduled": "Geplant",
  "billing.state.running": "Läuft",
  "billing.state.finished": "Beendet",
  "billing.state.ended_early": "Vorzeitig beendet",
  "billing.scope.pro": "Ein Profi",
  "billing.scope.country": "Ein Land",
  "billing.scope.category": "Ein Gewerk",
  "billing.priceState.in_force": "Gültig",
  "billing.priceState.scheduled": "Geplant",
  "billing.priceState.superseded": "Ersetzt",
  "billing.prices.intro": "Ein neuer Preis gilt nur für neue Abos. Ein Profi behält den Preis seines Abschlusses.",
  "billing.prices.loading": "Preise werden geladen…",
  "billing.prices.loadFailed": "Die Preise konnten nicht geladen werden.",
  "billing.prices.empty": "Noch kein Preis festgelegt.",
  "billing.prices.unpriced": "Ohne Preis: {plans}. Niemand kann sie abonnieren.",
  "billing.prices.imported": "Aus dem ursprünglichen Tarif",
  "billing.promos.intro":
    "Eine Aktion senkt den Preis eines Tarifs in einem Land für alle, die im Zeitfenster abschließen. Ein Profi erhält nur den niedrigsten Preis: Aktion und Rabatt werden nie addiert.",
  "billing.promos.loading": "Aktionen werden geladen…",
  "billing.promos.loadFailed": "Die Aktionen konnten nicht geladen werden.",
  "billing.promos.empty": "Derzeit keine Aktion.",
  "billing.discounts.intro":
    "Ein Rabatt ist ein Prozentsatz für einen Profi, ein Land oder ein Gewerk. Ein Profi erhält nur den niedrigsten Preis: Rabatt und Aktion werden nie addiert.",
  "billing.discounts.loading": "Rabatte werden geladen…",
  "billing.discounts.loadFailed": "Die Rabatte konnten nicht geladen werden.",
  "billing.discounts.empty": "Derzeit kein Rabatt.",
  "billing.col.name": "Bezeichnung",
  "billing.col.plan": "Tarif",
  "billing.col.country": "Land",
  "billing.col.currency": "Währung",
  "billing.col.amount": "Betrag",
  "billing.col.amountDue": "Offener Betrag",
  "billing.col.promoPrice": "Aktionspreis",
  "billing.col.percentOff": "Nachlass",
  "billing.col.periods": "Dauer",
  "billing.col.window": "Zeitfenster",
  "billing.col.state": "Status",
  "billing.col.status": "Zahlungsstatus",
  "billing.col.subscribers": "Profis darauf",
  "billing.col.createdBy": "Erstellt von",
  "billing.col.setBy": "Festgelegt von",
  "billing.col.reason": "Grund",
  "billing.col.validFrom": "Gültig ab",
  "billing.col.who": "Für wen",
  "billing.col.actions": "Aktionen",
  "billing.col.date": "Zeitpunkt",
  "billing.col.period": "Abgedeckter Zeitraum",
  "billing.col.provider": "Anbieter",
  "billing.col.eventKind": "Ereignis",
  "billing.col.via": "Eingang über",
  "billing.col.result": "Ergebnis",
  "billing.col.detail": "Einzelheit",
  "billing.col.eventRef": "Ereignis-Referenz",
  "billing.action.setPrice": "Preis festlegen",
  "billing.action.newPromo": "Neue Aktion",
  "billing.action.newDiscount": "Neuer Rabatt",
  "billing.action.endNow": "Jetzt beenden",
  "billing.action.endPromo": "Aktion beenden",
  "billing.action.endDiscount": "Rabatt beenden",
  "billing.action.extendSubscription": "Verlängern",
  "billing.action.endSubscription": "Abo beenden",
  "billing.dialog.setPrice.title": "Preis festlegen",
  "billing.dialog.setPrice.body":
    "Dieser Preis gilt für neue Abos in diesem Land. Bereits abonnierte Profis behalten ihren.",
  "billing.dialog.newPromo.title": "Neue Aktion",
  "billing.dialog.newPromo.body":
    "Der Aktionspreis ersetzt im Zeitfenster den Landespreis. Ein Profi behält ihn, solange das Abo läuft, bis zur angegebenen Grenze.",
  "billing.dialog.newDiscount.title": "Neuer Rabatt",
  "billing.dialog.newDiscount.body":
    "Wählen Sie genau ein Ziel: einen Profi, ein Land oder ein Gewerk. Ein Profi erhält nur den niedrigsten Preis: Rabatt und Aktion werden nie addiert.",
  "billing.dialog.endPromo.title": "Aktion {subject} beenden",
  "billing.dialog.endPromo.body": "Niemand kann sie mehr neu nutzen. Profis, die sie haben, behalten sie.",
  "billing.dialog.endDiscount.title": "Rabatt {subject} beenden",
  "billing.dialog.endDiscount.body": "Er gilt nicht mehr für neue Abos. Profis, die ihn haben, behalten ihn.",
  "billing.dialog.extendSubscription.title": "{subject} verlängern",
  "billing.dialog.extendSubscription.body":
    "Kulanz: Der Zugang läuft bis zum gewählten Datum, eine Sperre wird aufgehoben. Der Preis des Profis bleibt gleich.",
  "billing.dialog.endSubscription.title": "Abo {subject} beenden",
  "billing.dialog.endSubscription.body":
    "Der Zugang endet sofort und der Anbieter wird angewiesen, nicht mehr abzubuchen. Es gibt keine Erstattung: Gewähren Sie in Paiements ein Guthaben, falls eines fällig ist.",
  "billing.field.plan": "Tarif",
  "billing.field.pickPlan": "Tarif wählen",
  "billing.field.country": "Land",
  "billing.field.countryHint": "Zweibuchstabiger Code, zum Beispiel GN.",
  "billing.field.currency": "Währung",
  "billing.field.currencyHint": "Dreibuchstabiger Code, zum Beispiel GNF.",
  "billing.field.amount": "Preis ({currency})",
  "billing.field.validFrom": "Gültig ab (optional)",
  "billing.field.validFromHint": "Leer: Der Preis gilt sofort. Nie ein vergangenes Datum.",
  "billing.field.name": "Bezeichnung",
  "billing.field.nameHint": "Was das Team in der Liste sieht, zum Beispiel „Start Conakry“.",
  "billing.field.startsAt": "Beginn",
  "billing.field.endsAt": "Ende",
  "billing.field.periods": "Anzahl Zeiträume (optional)",
  "billing.field.periodsHint": "Leer: Der Profi behält den Preis, solange das Abo läuft.",
  "billing.field.scope": "Für wen",
  "billing.field.pro": "Der Profi",
  "billing.field.category": "Gewerk",
  "billing.field.pickCategory": "Gewerk wählen",
  "billing.field.percentOff": "Rabatt in Prozent",
  "billing.field.paidThrough": "Verlängern bis",
  "billing.field.paidThroughHint": "Ein künftiges Datum. Bis dahin läuft der Zugang.",
  "billing.problem.reason": "Nennen Sie einen Grund mit mindestens {min} Zeichen.",
  "billing.problem.plan": "Wählen Sie einen Tarif.",
  "billing.problem.country": "Geben Sie einen zweibuchstabigen Ländercode ein.",
  "billing.problem.currency": "Geben Sie einen dreibuchstabigen Währungscode ein.",
  "billing.problem.amount": "Geben Sie einen Betrag über null ein.",
  "billing.problem.validFrom": "Geben Sie ein gültiges Startdatum an.",
  "billing.problem.backdated": "Ein Preis kann nicht in der Vergangenheit beginnen.",
  "billing.problem.name": "Nennen Sie einen Namen mit mindestens {min} Zeichen.",
  "billing.problem.window": "Geben Sie Beginn und Ende an.",
  "billing.problem.windowOrder": "Das Ende muss nach dem Beginn liegen.",
  "billing.problem.periods": "Die Anzahl der Zeiträume muss eine ganze Zahl über null sein.",
  "billing.problem.pro": "Wählen Sie den betroffenen Profi.",
  "billing.problem.category": "Wählen Sie ein Gewerk.",
  "billing.problem.percentOff": "Der Prozentsatz muss eine ganze Zahl zwischen 1 und 100 sein.",
  "billing.problem.paidThrough": "Geben Sie ein gültiges Enddatum an.",
  "billing.problem.paidThroughPast": "Das Datum muss in der Zukunft liegen.",
  "billing.outcome.price": "Preis gespeichert: {amount}, ab {date}.",
  "billing.outcome.promoCreated": "Aktion „{name}“ erstellt.",
  "billing.outcome.promoEnded": "Aktion „{name}“ beendet. Profis, die sie haben, behalten sie.",
  "billing.outcome.discountCreated": "Rabatt „{name}“ erstellt.",
  "billing.outcome.discountEnded": "Rabatt „{name}“ beendet. Profis, die ihn haben, behalten ihn.",
  "billing.outcome.extended": "Abo bis {date} verlängert.",
  "billing.outcome.subscriptionEnded": "Abo beendet. Der Zugang ist gesperrt und der Anbieter bucht nicht mehr ab.",
  "billing.error.stale": "Das hat sich geändert, während Sie es angesehen haben. Neu laden, prüfen, erneut versuchen.",
  "billing.error.refused":
    "Abgelehnt: Ihren Rollen fehlt die nötige Funktion. Bitten Sie eine Führungskraft um Zugang.",
  "billing.error.invalid": "Abgelehnt: Das Gesendete passt nicht mehr. Neu laden und prüfen.",
  "billing.error.outcomeUnknown":
    "Keine Antwort vom Server: Es kann gespeichert worden sein. Erneut versuchen: Derselbe Klick wirkt nicht zweimal.",
  "billing.refused.planNotPriced": "Abgelehnt: Dieser Tarif hat in diesem Land noch keinen Preis. Zuerst festlegen.",
  "billing.refused.invalidAmount": "Abgelehnt: Der Betrag muss über null liegen.",
  "billing.refused.backdated": "Abgelehnt: Ein Preis kann nicht in der Vergangenheit beginnen.",
  "billing.refused.priceVersionExists":
    "Abgelehnt: Für diesen Tarif und dieses Land beginnt bereits eine Version zu diesem Zeitpunkt. Liste neu laden.",
  "billing.refused.invalidWindow": "Abgelehnt: Das Zeitfenster ist ungültig. Das Ende muss nach dem Beginn liegen.",
  "billing.refused.alreadyOver": "Abgelehnt: Das ist bereits beendet. Liste neu laden.",
  "billing.refused.idempotencyKeyRequired":
    "Abgelehnt: Die Anfrage ging ohne Schlüssel raus. Fenster schließen und neu beginnen.",
  "billing.subscription.pending": "Ausstehend",
  "billing.subscription.active": "Aktiv",
  "billing.subscription.ending": "Verlängert sich nicht",
  "billing.subscription.suspended": "Gesperrt",
  "billing.subscription.ended": "Beendet",
  "billing.endReason.renewal_cancelled": "Verlängerung vom Profi gekündigt",
  "billing.endReason.unpaid": "Verlängerung nicht bezahlt",
  "billing.endReason.checkout_abandoned": "Zahlung nie abgeschlossen",
  "billing.endReason.replaced": "Durch ein anderes Abo ersetzt",
  "billing.endReason.ended_by_staff": "Vom Team beendet",
  "billing.endReason.ended_by_provider": "Vom Anbieter beendet",
  "billing.event.payment_succeeded": "Zahlung erfolgreich",
  "billing.event.payment_failed": "Zahlung fehlgeschlagen",
  "billing.event.subscription_ended": "Abo beendet",
  "billing.via.webhook": "Anbieter-Webhook",
  "billing.via.poll": "Von Walliyo abgefragt",
  "billing.via.return": "Rückkehr in die App",
  "billing.via.reconcile": "Abgleich",
  "billing.result.applied": "Angewendet",
  "billing.result.conflict": "Konflikt",
  "billing.result.ignored": "Ignoriert",
  "billing.priceInsteadOf": "{now} statt {regular}",
  "billing.reductionWithPeriods": "{name} · noch {count} Zeiträume",
  "billing.sub.loading": "Abo wird geladen…",
  "billing.sub.loadFailed": "Das Abo konnte nicht geladen werden.",
  "billing.sub.none": "Dieser Profi war nie abonniert.",
  "billing.sub.credit": "Guthaben",
  "billing.sub.noCredit": "Keines",
  "billing.sub.noRefunds":
    "Für ein Abo gibt es keine Erstattung. Eine Geste ist ein Guthaben aus Paiements, das von der nächsten Zahlung abgezogen wird.",
  "billing.sub.creditLink": "Seine Zahlungen, um ein Guthaben zu gewähren →",
  "billing.sub.discountLink": "Diesem Profi einen Rabatt geben →",
  "billing.sub.since": "Eröffnet am {date}",
  "billing.sub.versionTitle": "Die angezeigte Abo-Version: Jede Schreibaktion sendet sie.",
  "billing.sub.entitled": "Zugang offen",
  "billing.sub.notEntitled": "Kein Zugang",
  "billing.sub.provider": "Anbieter",
  "billing.sub.renewsAutomatically": "verlängert sich automatisch",
  "billing.sub.paidByHand": "vom Profi selbst bezahlt",
  "billing.sub.country": "Land",
  "billing.sub.price": "Aktueller Preis",
  "billing.sub.reduction": "Ermäßigung",
  "billing.sub.nextPlan": "Tarifwechsel",
  "billing.sub.nextPlanValue": "wechselt am Ende des Zeitraums zu {plan}",
  "billing.sub.paidThrough": "Bezahlt bis",
  "billing.sub.renewalCancelled": "Verlängerung gekündigt am",
  "billing.sub.graceEnds": "Kulanzfrist endet",
  "billing.sub.ended": "Beendet am",
  "billing.sub.endReason": "Grund des Endes",
  "billing.sub.payments": "Zahlungen",
  "billing.sub.noPayments": "Keine Zahlung zu diesem Abo.",
  "billing.sub.noPeriod": "Noch nicht abgedeckt",
  "billing.sub.events": "Anbieter-Ereignisse",
  "billing.sub.noEvents": "Kein Anbieter-Ereignis.",
  "billing.sub.actions": "Auf dieses Abo einwirken",
  "billing.sub.actionsFoot":
    "Verlängern ist Kulanz, Beenden ist Durchsetzung. Beides verlangt einen Grund und steht im Prüfprotokoll.",
} as const;
